var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSinkUtility({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83,
    height: 120,
    viewBox: "0 0 83 120",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M15 83h5v37h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M15.5 83.5h4v36h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M63 83h5v37h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M63.5 83.5h4v36h-4z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M58.988 10h-6.244A4.502 4.502 0 0044 11.5V29h-6V10.5C38 4.701 42.701 0 48.5 0c5.631 0 10.227 4.433 10.488 10z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M58.45 9.5a10.002 10.002 0 00-19.95 1v18h5v-17a5 5 0 019.584-2h5.367z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M56.5 19c1.667-.796 2.5-1.685 2.5-2.667 0-.982-.833-2.76-2.5-5.333-1.667 2.574-2.5 4.351-2.5 5.333 0 .982.833 1.871 2.5 2.667z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M56.5 18.443c1.363-.69 2-1.403 2-2.11 0-.773-.666-2.264-2-4.401-1.334 2.137-2 3.628-2 4.401 0 .707.637 1.42 2 2.11z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 9,
    height: 4,
    x: 51,
    y: 9,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 8,
    height: 3,
    x: 51.5,
    y: 9.5,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M4 38h75l-5.073 46H9.073z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M4.558 38.5l4.963 45H73.48l4.963-45H4.558z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M26 28h30v5H26z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M26.5 28.5h29v4h-29z"
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 7,
    height: 9,
    x: 28,
    y: 19,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 6,
    height: 8,
    x: 28.5,
    y: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-fill",
    width: 7,
    height: 9,
    x: 47,
    y: 19,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    "data-svg-class": "RoomButton-stroke",
    width: 6,
    height: 8,
    x: 47.5,
    y: 19.5,
    rx: 2
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-fill",
    d: "M0 32h83v7H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-svg-class": "RoomButton-stroke",
    d: "M.5 32.5h82v6H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSinkUtility);
export default __webpack_public_path__ + "static/media/RoomSinkUtility.40d3ce2ee1faed40f57c7f88ea284cdc.svg";
export { ForwardRef as ReactComponent };